import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { jobService } from '../../services/jobService';
import { useSite } from '../../context/SiteContext';
import ApplyModal from '../../components/careers/ApplyModal';
import { FALLBACK_JOBS } from '../../services/fallbackData';

export default function WelcomeBioPage() {
  const { settings } = useSite();
  const [jobs, setJobs] = useState(FALLBACK_JOBS);
  const [isApplyOpen, setIsApplyOpen] = useState(false);

  useEffect(() => {
    jobService
      .getPublicJobs()
      .then((res) => {
        if (res.data && res.data.length > 0) setJobs(res.data);
      })
      .catch(() => {});
  }, []);

  return (
    <div className="bio-page" style={{ maxWidth: '580px', margin: '0 auto', padding: '32px 16px', minHeight: '100vh' }}>
      {/* Header Profile */}
      <div style={{ textAlign: 'center', marginBottom: '28px' }}>
        <img
          src="/assets/img/logo-icon.svg"
          alt="Thế Thảo Pharma"
          width="80"
          height="80"
          style={{ margin: '0 auto 12px auto', display: 'block' }}
        />
        <h1 style={{ fontSize: '1.4rem', margin: '0 0 6px 0', color: '#005b31' }}>
          THẾ THẢO PHARMA · CAREERS
        </h1>
        <p className="lead" style={{ fontSize: '0.95rem', margin: 0, color: '#64748b' }}>
          Nhà phân phối dược phẩm &amp; TPCN OTC · Đồng hành cùng 20.000+ nhà thuốc
        </p>
      </div>

      {/* Action Links */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '32px' }}>
        <button
          type="button"
          className="btn btn--primary"
          onClick={() => setIsApplyOpen(true)}
          style={{ justifyContent: 'center', padding: '14px', fontSize: '1.05rem', borderRadius: '12px' }}
        >
          🚀 Nộp CV ứng tuyển trực tuyến
        </button>

        <a
          href={`tel:${settings.contact_phone_hr || '0989729095'}`}
          className="btn btn--ghost"
          style={{ justifyContent: 'center', padding: '12px', borderRadius: '12px', background: '#fff', border: '1px solid #cbd5e1' }}
        >
          📞 Hotline Nhân sự: {settings.contact_phone_hr || '0989.729.095'}
        </a>

        <a
          href={`https://zalo.me/${settings.contact_phone_hr || '0989729095'}`}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn--ghost"
          style={{ justifyContent: 'center', padding: '12px', borderRadius: '12px', background: '#fff', border: '1px solid #cbd5e1' }}
        >
          💬 Chat Zalo trực tiếp với HR
        </a>

        <Link
          to="/"
          className="btn btn--ghost"
          style={{ justifyContent: 'center', padding: '12px', borderRadius: '12px', background: '#fff', border: '1px solid #cbd5e1' }}
        >
          🌐 Xem Website chính thức
        </Link>
      </div>

      {/* Danh sách vị trí tuyển dụng */}
      <div style={{ marginBottom: '24px' }}>
        <h3 style={{ fontSize: '1.15rem', marginBottom: '16px', color: '#1e293b' }}>
          Vị trí đang tuyển ({jobs.length})
        </h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {jobs.map((job) => (
            <div
              key={job.id}
              style={{
                background: '#fff',
                padding: '16px 20px',
                borderRadius: '12px',
                border: '1px solid #e2e8f0',
                boxShadow: '0 2px 8px rgba(0,0,0,0.03)'
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
                <span style={{ fontSize: '0.8rem', fontWeight: 700, color: '#16a34a', textTransform: 'uppercase' }}>
                  {job.department}
                </span>
                {job.headcount > 0 && (
                  <span style={{ fontSize: '0.8rem', color: '#64748b' }}>Tuyển {job.headcount}</span>
                )}
              </div>
              <h4 style={{ margin: '0 0 6px 0', fontSize: '1.05rem' }}>{job.title}</h4>
              {(job.salary_summary || job.salary) && (
                <p style={{ margin: 0, fontSize: '0.9rem', color: '#475569' }}>
                  <strong>Thu nhập:</strong> {job.salary_summary || job.salary}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Footer nhỏ */}
      <div style={{ textAlign: 'center', fontSize: '0.8rem', color: '#94a3b8', marginTop: '32px' }}>
        © 2026 Thế Thảo Pharma · Đồng hành vững vàng — Nhà thuốc vươn xa
      </div>

      <ApplyModal
        isOpen={isApplyOpen}
        onClose={() => setIsApplyOpen(false)}
        source="welcome-bio"
      />
    </div>
  );
}
